import AntForm from '@9troisquarts/ant-form'
import AntFormGooglePlaces from '../react/shared/components/AntFormGooglePlaces/AntFormGooglePlaces'
import { googlePlacesCountries, type SupportedLocale } from './localeRegistry'
import { GOOGLE_PLACES_API_KEY } from './googleMapsLoader'

export { GOOGLE_PLACES_API_KEY }

type LocationFieldOptions = {
  selectProps?: Record<string, unknown>
}

export const configureLocationField = (locale: SupportedLocale, options: LocationFieldOptions = {}): void => {
  AntForm.addField('location', {
    component: AntFormGooglePlaces,
    apiKey: GOOGLE_PLACES_API_KEY,
    autocompletionRequest: {
      componentRestrictions: { country: googlePlacesCountries(locale) }
    },
    ...options
  })
}
